/*
 * @Author: cheesekun
 * @Date: 2021-03-02 10:06:41
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-03-02 10:19:38
 * @FilePath: \dc-important-act\src\components\Tip\notification.js
 */
import Tip from './index.vue'
import Vue from 'vue'

Tip.newInstance = properties => {
  const props = properties || {}
  const Instance = new Vue({
    data: props,
    render (h) {
      return h(Tip, {
        props
      })
    }
  })

  const component = Instance.$mount()
  document.body.appendChild(component.$el)

  const tip = Instance.$children[0]

  return {
    add (noticeProps) {
      tip.add(noticeProps)
    },
    remove (name) {
      tip.remove(name)
    }
  }
}

export default Tip
